module.exports = __webpack_public_path__ + "img/visa.49c4bca4.svg";